import React, {ChangeEvent, useState} from "react";

import {Button, Input} from "@chakra-ui/react";

import {TeqCustomerDto} from "./api/dtos";

import TeqCustomerGauge from "./teq-customer-gauge";

function AutomatedTeqCustomerResult() {
    const [value, setValue] = useState<string>("");
    const [response, setResponse] = useState<TeqCustomerDto | null>(null);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
    }

    const onSubmit = async () => {
        if (value) {
            const parsedResponse: TeqCustomerDto = JSON.parse(value);

            setResponse(parsedResponse);
        }
    }

    if (!response) {
        return (
            <form>
                <Input value={value}
                       onChange={handleChange}
                       name="input"/>

                <Button name="submit" onClick={onSubmit} type="submit">Submit</Button>
            </form>
        );
    } else {
        return (
            <div id="diagnostic-results">
                <TeqCustomerGauge teq={response}/>
            </div>
        )
    }
}


export default AutomatedTeqCustomerResult;
